export function getTimeUnit(timestampArg) {
    switch (timestampArg.type) {
        case "IDENT":
        case "CALL_NAME":
            throw new Error(`Unknown time unit`);
    }
    switch (timestampArg.data.type.name) {
        case "DATE_TIME":
        case "TIMESTAMP":
            switch (timestampArg.data.type.unit) {
                case "MICROS":
                case "MILLIS":
                case "SECOND":
                    return timestampArg.data.type.unit;
            }
        default:
            throw new Error(`Unknown time unit`);
    }
}
export function nodeToMs(node) {
    switch (node.type) {
        case "DATE_TIME_LITERAL":
        case "NUMBER_LITERAL": {
            const value = +node.value;
            switch (getTimeUnit(node)) {
                case "MICROS":
                    return value / 1000;
                case "SECOND":
                    return value * 1000;
                case "MILLIS":
                    return value;
                default:
                    throw new Error(`Unknown time unit`);
            }
        }
    }
    throw new Error(`Cannot get time unit of node with type ${node.type}`);
}
